import { Expression, FilterCondition } from '../../types';

const getSpecialFieldCases = (key: string) => {
  switch (key) {
    case 'record_sequence':
      return 'record_key';
    case 'date_filter':
      return 'server_updated_at';
    case 'to':
      return 'form_values.ccc1';
    case 'basic_task_photo':
      return 'form_values.8125';
    default:
      return key;
  }
};

// Hopefully this is temporary - if we can convert RecordFilters/TaskFilters
// to use an Expression (and move "key" values into "field"), we can skip this step
export default function convertRecordFilters(filters: FilterCondition[]): Expression[] {
  const expressions: Expression[] = [];

  filters.forEach((filter) => {
    const { key } = filter;
    const value = filter.values;

    if (key === 'basic_issue_photos') {
      expressions.push(
        { field: 'form_values.7a79', value: value as string[], options: filter.options },
        { field: 'form_values.49bc', value: value as string[], options: filter.options },
      );
    } else {
      const field = getSpecialFieldCases(key);
      expressions.push({ field, value: value as string[], options: filter.options });
    }
  });
  return expressions;
}
